import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import { ErrorsStudentImportPage } from 'teacher-ui-client/components/errors/student-import-page'

export const ManageRolloverStepsStudentsImportErrorPage: TOC<unknown> = <template>
  <ErrorsStudentImportPage class="m-4" />
</template>

export default RouteTemplate(ManageRolloverStepsStudentsImportErrorPage)
